exports.wrapRootElement = require('./wrap-with-helmet').wrapRootElement
